export const CLEAR_CARBURETOR = "CLEAR_CARBURETOR";
export const CHANGE_CARBURETOR = "CHANGE_CARBURETOR";
export const UPDATE_CARBURETOR = "UPDATE_CARBURETOR";

export const PENDING_CREATE_CARBURETOR = "PENDING_CREATE_CARBURETOR";
export const CLOSE_PENDING_CREATE_CARBURETOR = "CLOSE_PENDING_CREATE_CARBURETOR";

export const CHANGE_CARBURETOR_BALANCE = "CHANGE_CARBURETOR_BALANCE";
